(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("locale/locale_ru", [], factory);
	else if(typeof exports === 'object')
		exports["locale/locale_ru"] = factory();
	else
		root["locale/locale_ru"] = factory();
})(window, function() {
return 